export function RentStatus() {
  return {
      setStatus: function (rentedOut) {
        this.rentedOut = rentedOut
        if(!rentedOut){
          this._fromDate = ''
          this._toDate = ''
        }
      },
      setFromDate: function (date) { this._fromDate = date },
      setToDate: function (date) { this._toDate = date }
  };
}



// WEBPACK FOOTER //
// ./src/model/rentStatus.js